module.exports = __webpack_public_path__ + "img/vaccines.0f44a2ec.png";